/* eslint-disable react/destructuring-assignment */
import React, { useEffect } from 'react';
import Card from '../../../../../components/Card';
import {
  OverviewGridItem,
  PropertyEstimate,
  Loader,
  EstimateCardHeader,
} from './components';

import { useValueEstimate } from '../../../../../api/hooks';
import { useActiveProperty } from '../../../../../store/hooks';
import { useSectionStyles } from './sectionStyles';

function PropertyEstimateSection({
  showMaxwidth,
  hasValueEstimateError,
  hideValues,
}) {
  const classes = useSectionStyles();

  const { property } = useActiveProperty();

  const valueEstimate = useValueEstimate();

  useEffect(() => {
    if (!property?.boligmappaNumber) return;

    valueEstimate.executeFetch();

    if (valueEstimate.error) {
      hasValueEstimateError(true);
    } else {
      hasValueEstimateError(false);
    }
  }, [property?.boligmappaNumber]);

  const displayValueEstimate =
    !valueEstimate.isLoading && property.valueEstimate;
  if (valueEstimate.isLoading) {
    return (
      <>
        <OverviewGridItem showMaxwidth={showMaxwidth}>
          <Card className={classes.estimateCard}>
            <EstimateCardHeader
              classes={classes}
              displayIcon
              isLoading={valueEstimate.isLoading}
              editButtonLink={valueEstimate.data?.linktovirdi}
            />

            {valueEstimate.isLoading && <Loader />}
          </Card>
        </OverviewGridItem>
      </>
    );
  }

  return (
    <>
      {!valueEstimate.error &&
        valueEstimate.data &&
        !valueEstimate.isLoading && (
          <OverviewGridItem showMaxwidth={showMaxwidth}>
            <Card className={classes.estimateCard}>
              <EstimateCardHeader
                classes={classes}
                isLoading={valueEstimate.isLoading}
              />

              {displayValueEstimate && (
                <>
                  <PropertyEstimate
                    data={property.valueEstimate}
                    hideValues={hideValues}
                  />
                </>
              )}
            </Card>
          </OverviewGridItem>
        )}
    </>
  );
}

export default PropertyEstimateSection;
